// User-configurable default for the Maßkette visualisation toggle
// (Toleranz vs. Nennmaß), persisted in localStorage.
//
// The MassketteDiagram reads this at first render via a lazy
// useState initializer so the user's preference survives reload
// without an effect+setState dance. Toggling the in-app switch also
// writes here so the choice is sticky across sessions.
//
// Default is 'toleranz' (Wirkrichtung des Toleranzbandes), per the
// hand-off: the chain visual is more diagnostic in tolerance mode.
// Settings → Anzeige lets the user flip the default to 'nennmass'.

export const CHAIN_VIEW_LS_KEY = 'toleranz_chain_view_default';

const VALID = new Set(['toleranz', 'nennmass']);

export function loadChainViewDefault() {
  if (typeof localStorage === 'undefined') return 'toleranz';
  try {
    const raw = localStorage.getItem(CHAIN_VIEW_LS_KEY);
    return VALID.has(raw) ? raw : 'toleranz';
  } catch {
    return 'toleranz';
  }
}

export function saveChainViewDefault(value) {
  if (typeof localStorage === 'undefined') return;
  if (!VALID.has(value)) return;
  try {
    localStorage.setItem(CHAIN_VIEW_LS_KEY, value);
  } catch { /* ignore */ }
}
